
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/legal/[documentName]",
      function () {
        return require("private-next-pages/legal/[documentName].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/legal/[documentName]"])
      });
    }
  